import React from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import styles from './CarEditorProfileSelector.styles';
import { zIndex } from '../../theme/theme';
import { selectFleets } from '../../redux/store/appData/fleets';

const { Option } = Select;

type Props = {
  style?: any;
  className?: string;
  defaultValue?: string;
  value?: any;
  disabled?: boolean;
  loading?: boolean;
  placeholder?: string;
  onSelect?: (value: string) => void;
};

const FleetSelector: React.FC<Props> = ({
  style,
  className,
  defaultValue,
  value,
  disabled,
  loading,
  placeholder,
  onSelect,
}) => {
  const fleets = useSelector(selectFleets) as any;

  return (
    <div style={style} className={className}>
      <Select
        dropdownStyle={{ zIndex: zIndex.dropDown }}
        defaultValue={defaultValue}
        style={{ width: '100%' }}
        disabled={disabled}
        loading={loading}
        placeholder={placeholder}
        onChange={onSelect}
      >
        {[...fleets]
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((fleet) => (
            <Option key={`fleet-option-${fleet.id}`} value={fleet.id}>
              {fleet.name}
            </Option>
          ))}
      </Select>
      <style jsx>{styles}</style>
    </div>
  );
};

export default FleetSelector;
